import { startClock } from '../../services/timesheetsService'

export interface StoppedClockInfo {
  workspaceId?: string
  nodeId?: string | null
  source?: string
  [key: string]: unknown
}

export interface ShowStoppedTimerUndoToastOptions {
  workspaceId: string
  stoppedClock: StoppedClockInfo
  showToast: (
    message: string,
    variant?: 'info' | 'success' | 'warning' | 'error' | 'ghost',
    action?: { label: string; run: () => void | Promise<void> },
  ) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: (key: any, argsOrFallback?: any, fallback?: string) => string
}

export function showStoppedTimerUndoToast({
  workspaceId,
  stoppedClock,
  showToast,
  t,
}: ShowStoppedTimerUndoToastOptions): void {
  showToast(
    t('NLSTimesheetsPreviousTimerStopped'),
    'info',
    {
      label: t('NLSTimesheetsUndo'),
      run: async () => {
        await startClock({
          workspaceId,
          nodeId: stoppedClock.nodeId ?? null,
          kind: stoppedClock.source === 'TIMER' ? 'TIMER' : 'CLOCK',
        })
      },
    },
  )
}
